export type ReviewLike = {
  overall: number;
  cleanliness?: number | null;
  communication?: number | null;
  accuracy?: number | null;
  valueScore?: number | null;
  respectRules?: number | null;
};

// Blend the user-inputted "overall" rating with the average of the per-criterion
// scores so every star they provided counts. If no criteria were rated, fall
// back to the raw overall.
//   blended = (overall + avg(criteria)) / 2
export function blendedRating(r: ReviewLike): number {
  const criteria = [
    r.cleanliness,
    r.communication,
    r.accuracy,
    r.valueScore,
    r.respectRules,
  ].filter((v): v is number => typeof v === "number");

  if (criteria.length === 0) return r.overall;

  const criteriaAvg = criteria.reduce((s, v) => s + v, 0) / criteria.length;
  return (r.overall + criteriaAvg) / 2;
}

export function averageBlendedRating(reviews: ReviewLike[]): number | null {
  if (reviews.length === 0) return null;
  const sum = reviews.reduce((s, r) => s + blendedRating(r), 0);
  return sum / reviews.length;
}
